import { FixedColumn } from '../FixedColumn';
import { LayoutIndent } from '../../lib/consts/LayoutConstants';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';

interface props {
  selected: boolean;
  toggle: (val: boolean) => void;
  children: React.ReactNode;
}

const SmartSendItemSelect: React.FC<props> = (props) => {
  return (
    <FixedColumn
      alignment="left"
      right={props.children}
      left={
        <P2GCheckBoxLegacy
          id=""
          onChange={() => props.toggle(!props.selected)}
          checked={props.selected}
          labelPlacement="end"
          variant="primary"
          error={false}
        />
      }
      width={LayoutIndent}
    />
  );
};

export { SmartSendItemSelect };
